import _ from 'lodash';

function identity(arg) {
  return arg;
}

/**
 * Searches through a collection of urls (e.g. /pages/about) and compares each URL with the
 * given path. The match is partial – as long as the url argument can be found in the start of
 * the path we have a match.
 *
 * Note that the while /abc/def matches both /abc and /abc/def, it doesn't match just /a.
 */
export function findByUrlPartial(collection, path, select = identity) {
  return _.find(collection, item => new RegExp(`^${select(item)}(\\?|/|$)`).test(path)) || false;
}



// WEBPACK FOOTER //
// ./src/util/urls.js